export const ServiceWorkerOptions = {
  showUnverifiedSignatures: false
};

(window as any).ServiceWorkerOptions = ServiceWorkerOptions;
